import type { SuccessLoveMap } from "@/components/PaymentSuccessScreen";
import type { LoveMapResponse } from "@/types/tarot";

/** Map the server-snapshotted love map add-on to the success screen props. */
export function toSuccessLoveMap(
  loveMap: LoveMapResponse | null | undefined,
): SuccessLoveMap | null {
  if (!loveMap) return null;
  return {
    forecastYear: loveMap.forecast_year,
    feeCents: loveMap.fee_cents,
    deliveryTargetHours: loveMap.delivery_target_hours,
  };
}
